var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 7.49996C12.0832 8.65054 11.1504 9.58329 9.99984 9.58329C8.84925 9.58329 7.9165 8.65054 7.9165 7.49996C7.9165 6.34937 8.84925 5.41663 9.99984 5.41663C11.1504 5.41663 12.0832 6.34937 12.0832 7.49996Z",
    stroke: "#656F7D",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1853 14.1666C16.3474 15.8237 16.9033 16.7062 16.5722 17.4165C16.539 17.4878 16.5001 17.5565 16.4559 17.6222C15.9772 18.3333 14.7397 18.3333 12.265 18.3333H7.73535C5.26059 18.3333 4.0232 18.3333 3.54442 17.6222C3.5002 17.5565 3.46132 17.4878 3.42812 17.4165C3.09699 16.7062 3.65288 15.8237 4.81498 14.1666",
    stroke: "#656F7D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0477 14.578C10.7666 14.8486 10.3909 15 10 15C9.609 15 9.23334 14.8486 8.95225 14.578C6.37842 12.084 2.92916 9.29788 4.61126 5.25307C5.52075 3.06606 7.70395 1.66663 10 1.66663C12.296 1.66663 14.4792 3.06607 15.3887 5.25307C17.0687 9.29279 13.6278 12.0925 11.0477 14.578Z",
    stroke: "#656F7D",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveLocation);
export default __webpack_public_path__ + "static/media/inactive-location.6b190849ae467a50c3869e13cfcf6173.svg";
export { ForwardRef as ReactComponent };